/**
 * Implements the page metadata folder.
 */
export default class PageMetaFolder {
	constructor() {
		if ( ! document.querySelector( '.right-sidebar__folding-bar' ) ) {
			return;
		}
		this.unfolder = document.querySelector( '.right-sidebar__unfolder' );
		this.folder = document.querySelector( '.right-sidebar__folder' );
		this.wrap = document.querySelector( '.sidebar-and-content-wrap' );
		const self = this;
		const handleFold = function() {
			self.wrap.classList.toggle( 'sidebar-and-content-wrap--folded-meta' );
			self.saveSetting(
				! self.wrap.classList.contains( 'sidebar-and-content-wrap--folded-meta' )
			);
		};
		[ this.unfolder, this.folder].forEach(
			function( x ) {
				x.addEventListener( 'click', ( e ) => {
					e.preventDefault();
					handleFold();
				} );
			}
		);
		const content = document.getElementById( 'content' );
		const sideBar = document.querySelector( '.right-sidebar' );
		if ( content && sideBar ) {
			content.addEventListener(
				'click',
				( e ) => {
					if ( ! self.wrap.classList.contains(
						'sidebar-and-content-wrap--folded-meta'
					)
							 && ! sideBar.contains( e.target )
							 && window.matchMedia( '(max-width: 991px)' ).matches
						 ) {
						e.preventDefault();
						handleFold();
					}
				}
			);
			document.body.addEventListener(
				'iportal-core:toc-scroll-end',
				() => { window.matchMedia( '(max-width: 991px)' ).matches && handleFold(); }
			);
		}
	};

	/**
	 * Saves the current setting via XHR.
	 */
	async saveSetting( unfolded ) {
		const opts = {
			headers: {
				'X-WP-Nonce': wpApiSettings.nonce,
			},
			method: 'PUT',
			body: JSON.stringify(
				{
					key: 'meta_unfolded',
					value: unfolded,
				}
			),
		};
		await fetch(
			wpApiSettings.root + 'iportal/v1/user_options',
			opts
		);
	};
};
